// // Use $ instead of jQuery without replacing global $
(function ($) {
    // On DOM ready
    $(document).ready(function () {
        $('.tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel').hide();
        $('.tab-content-img-grid').css({'opacity': '0'});
        // if($(".tab-content-img-grid .tab-panel .tab-content").length > 0){
        //     $('.tab-content-img-grid .tab-panel .tab-content:eq(1)').addClass('n-active');
        // }
        $('.tab-content-img-grid .tab-grid-outer .tab-list .panel-outer ul > li > span').click(function () {
            var currentIndex = $('.tab-content-img-grid .tab-panel .tab-content.active').index();
            var index = $(this).parent('li').index();
            if(index != currentIndex){
                var length = $(this).parents('ul').find('li').length;
                var $thisText = jQuery(this).text();
                $(this).parents('.panel-outer ul').find('li').removeClass('active');
                $(this).parent('li').addClass('active');
                var prevIndex;
                var lastprevIndex;
                var nextIndex;
                if((index-1) >= 0){
                    prevIndex = (index-1);
                }
                if((index-2) >= 0){
                    lastprevIndex = (index-2);
                    $('.tab-content-img-grid .tab-panel .tab-content:eq('+ lastprevIndex +')').removeClass('active p-active n-active');
                }
                if((index+1) <= length){
                    nextIndex=(index+1);
                    $('.tab-content-img-grid .tab-panel .tab-content:eq('+ nextIndex +')').addClass('n-active').removeClass('active p-active');
                }
                $('.tab-content-img-grid .tab-panel .tab-content:eq('+ currentIndex +')').addClass('p-active').removeClass('active n-active');
                if(index === (length - 1)){
                    $(this).parents('.tab-list').find('.tab-panel .tab-content:eq(' + index + ')').addClass('active').removeClass('n-active');
                    $('.tab-content-img-grid .tab-panel .tab-content:eq(0)').addClass('n-active').removeClass('active p-active');
                }else{
                    $(this).parents('.tab-list').find('.tab-panel .tab-content:eq(' + index + ')').addClass('active').removeClass('n-active');
                }
                setTimeout(function () {
                    $('.tab-content-img-grid .tab-panel .tab-content').removeClass('p-active');
                    // if((index+1) <= length){
                    //     nextIndex=(index+1);
                    //     $('.tab-content-img-grid .tab-panel .tab-content:eq('+ nextIndex +')').addClass('n-active').removeClass('active p-active');
                    // }
                },800);
            }

        });


        $('.tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel button').click(function () {
            windowWidth = jQuery(window).width();
            if (window.matchMedia('(max-width: 991px)').matches){
                $('.tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel .dropdown').slideToggle();
                $('.tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel button').toggleClass('close-up');
            }
        });
        $(".tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel .dropdown li span").on("click", function () {
            $('.tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel button').toggleClass('close-up');

            var value = $(this).text();
            windowWidth = jQuery(window).width();
            if (window.matchMedia('(max-width: 991px)').matches) {
                $(".tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel button span").text(value);
                $(".tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel .dropdown").slideUp();
                $(".tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel .dropdown li").removeClass('active');
            }
        });

        $('body .tab-content-img-grid .tab-grid-outer .tab-panel .tab-content .col-img-wrap .content-img').matchHeight();
    });


    //On load function
    $(window).on("load resize", function () {
        $('.tab-content-img-grid').css({'opacity': '1'});
        windowWidth = jQuery(window).width();
        if (window.matchMedia('(max-width: 991px)').matches) {
            $('.tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel').show();
            $('.tab-content-img-grid .tab-grid-outer .tab-list .panel-outer ul').hide();
            $('.tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel button').removeClass('close-up');

        }
        else {
            $('.tab-content-img-grid .tab-grid-outer .tab-list .panel-outer ul').show();
            $('.tab-content-img-grid .tab-grid-outer .tab-list .panel-outer .mobile-panel').hide();
        }
    });


})(jQuery);

